// Read-more | read-less 
document.addEventListener('DOMContentLoaded', () => {
  function toggleVisibility(readMoreElement, readLessElement) {
    readMoreElement.classList.toggle('hidden');
    readLessElement.classList.toggle('hidden');
  }
  
  function addToggleEventListener(readMoreBtn, readLessBtn, readMoreElement, readLessElement) {
    readMoreBtn?.addEventListener('click', (event) => {
      event.preventDefault();
      toggleVisibility(readMoreElement, readLessElement);
    });
  
    readLessBtn?.addEventListener('click', (event) => {
      event.preventDefault();
      toggleVisibility(readMoreElement, readLessElement);
    });
  }
  
  let readMoreElement = document.querySelector('#custom-description .read-more');
  let readLessElement = document.querySelector('#custom-description .read-less');
  let readMoreBtn = document.querySelector('#custom-description .read-more-btn');
  let readLessBtn = document.querySelector('#custom-description .read-less-btn');
  addToggleEventListener(readMoreBtn, readLessBtn, readMoreElement, readLessElement);
  
  let mobileReadMoreElement = document.querySelector('#mobile-custom-description .read-more');
  let mobileReadLessElement = document.querySelector('#mobile-custom-description .read-less');
  let mobileReadMoreBtn = document.querySelector('#mobile-custom-description .read-more-btn');
  let mobileReadLessBtn = document.querySelector('#mobile-custom-description .read-less-btn');
  addToggleEventListener(mobileReadMoreBtn, mobileReadLessBtn, mobileReadMoreElement, mobileReadLessElement);
})

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);
    
    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    
    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    // Returning if browser is safari as filters dont retain when coming back from PDP.
    if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) return;
    
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    
    if (countContainer){
      countContainer.classList.add('loading');
    }
    
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        window.newHtml = new DOMParser().parseFromString(html, 'text/html')
        FacetFiltersForm.renderProductGridContainer(html);
        // FacetFiltersForm.renderProductCount(html);
      const customEvent = new Event('quick-add');
      document.dispatchEvent(customEvent);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    // FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  // static renderProductCount(html) {
  //   const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
  //   const container = document.getElementById('ProductCount');
  //   const containerDesktop = document.getElementById('ProductCountDesktop');
  //   container.innerHTML = count;
  //   container.classList.remove('loading');
  //   if (containerDesktop) {
  //     containerDesktop.innerHTML = count;
  //     containerDesktop.classList.remove('loading');
  //   }
  // }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
   
    //for desktop details summary filters
    const filterDetails =document.querySelectorAll("details[data-filterName]");
    filterDetails.forEach((ele)=>{
     let matchesvalue = ele.getAttribute("data-filterName")
     let filterNames =parsedHTML.querySelector(`details[data-filterName='${matchesvalue}'] ul.facets__list`)?.innerHTML
     if (filterNames) {
     ele.querySelector("ul.facets__list").innerHTML = filterNames;
     }
     else{
      ele.querySelector("ul.facets__list").innerHTML ="<div class='no-filter-value-desktop'>No Filters Values are Present</div>"
    }
    })
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);


    //for mobile sticky filter
    //replacing the innerHtml while filtering
    document.querySelectorAll(".filters-values-discount[data-label]").forEach((items)=>{
    let data_label = items.dataset.label
    if (data_label === "Price") {
      return;
    }
    let matchesvalue = parsedHTML.querySelector(`[data-label="${data_label}"] ul.mobile-facets__list`)?.innerHTML
    if (matchesvalue) {
      items.querySelector('ul.mobile-facets__list').innerHTML = matchesvalue
    }
    else{
      items.querySelector('ul.mobile-facets__list').innerHTML = "<div class='no-filter-value'>No Filters Values are Present</div>"
    }
    })


    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));

    window.hideActiveInstockFacet();
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    // history.pushState method updates the URL without triggering a page reload
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);

    const maxrange = document.querySelector(".max-price");
    const maxbubble = document.querySelector(".max-price_bubble");
    let minInput = document.querySelector("#Filter-Price-GTE");

    //for Mobile
    const MobileMaxrange = document.querySelector(".max-range_mobile");
    const MobileMaxinbubble = document.querySelector(".mobile-max_bubble");

    function setMaxBubble(range, maxbubble) {
      const val = range.value;
      maxbubble.innerHTML = val;
    }

    setMaxBubble(MobileMaxrange, MobileMaxinbubble);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form, target) {

    // This is a special case for Filters when using Drawer in Desktop.
    // When filter type is drawer, the same Mobile filter is rendered twice in differnt forms.
    // Dropdown UI in Desktop and Tab switching UI in Mobile.
    // Due to this, the same filter ends up having duplicate inputs with the same name and id.
    // When FormData is created, input with Checked value will be consider for building data.
    // As we have two inputs with same attributes, when one is unchecked (the current target input) 
    // the second one will be consider for building the data
    // As a result, searchParams will be built using these values, which are then used to fetch the data.
    // After re-rendering, the target input gets checked again, making it look like nothing has changed.
    // To fix this, we also uncheck the other input so that its value is not included in searchParams.
    // This ensures the filter is properly removed.
    
    const isDesktopDrawer = form.closest(".facets-container-drawer")
    
    if (form.id === "FacetFiltersFormMobile" && target && !target.checked && isDesktopDrawer) {
      const inputs = form.querySelectorAll(`input[name='${target.name}']`) || []

      if (inputs.length > 1) {
        const similarInput = Array.from(inputs).find(inp => inp.checked && inp.value === target.value)
        if (similarInput) similarInput.checked = false
      }
    }

    const formData = new FormData(form);
    // This will be used for checking the formdata
    // for (let [key, value] of formData.entries()) {
    //   console.log(key, value);
    // }
    
    // Check if min and max values are equal for the price range
    const minPrice = formData.get('filter.v.price.gte');
    const maxPrice = formData.get('filter.v.price.lte');
    
    var compareMinInputValue = form.querySelector('price-range .min-price_wrapper input').getAttribute('value');
    var compareMaxInputValue = form.querySelector('price-range .max-price_wrapper input').getAttribute('value');

    compareMinInputValue = String(parseFloat(compareMinInputValue));
    compareMaxInputValue = String(parseFloat(compareMaxInputValue));
    
    if (minPrice === compareMinInputValue && maxPrice === compareMaxInputValue) {
      formData.delete('filter.v.price.gte');
      formData.delete('filter.v.price.lte');
    }

    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');

    if (event.srcElement.className == 'mobile-facets__checkbox') {

      let searchParams = this.createSearchParams(event.target.closest('form'), event.target);
      const activeSortByValue = document.querySelectorAll(".custom-sort-by-value.active") || [];

      if (activeSortByValue.length > 0 && activeSortByValue[0].dataset.sortValue) {
        const value = '&sort_by=' + activeSortByValue[0].dataset.sortValue;
        searchParams += value;
      }

      if (searchParams && !searchParams.includes('filter.v.availability=1')) {
        searchParams += '&filter.v.availability=1';
      }
      // If it contains only availability filter, remove that and clear active sortby value
      if (searchParams === "filter.v.availability=1") {
        if (activeSortByValue.length > 0) activeSortByValue.forEach(el => el.classList.remove("active"))
      }
      this.onSubmitForm(searchParams, event);

    } else {

      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';
      const captionElement = document.querySelector('.active-facets-desktop');

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            
            let existingParams = this.createSearchParams(form);

            if (existingParams && !existingParams.includes('filter.v.availability=1')) {
                existingParams += '&filter.v.availability=1';
            }
          
            forms.push(existingParams);
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
            forms.push(this.createSearchParams(form));
        }
      });
      
      this.onSubmitForm(forms.join('&'), event);
      
      if(captionElement) captionElement.classList.remove('hidden');
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    let url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);

    // Used to show only the available products which helps during pagination
    if (!Boolean(url)) url = "filter.v.availability=1"

    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();

    this.MIN_GAP = 1500;
    this.isUpdating = false; // prevent infinite loops

    this.cacheElements();
    this.bindEvents();
    this.updateAll();
  }

  cacheElements() {
    this.groups = {
      desktop: {
        minRange: document.querySelector("#Filter-Price-GTE"),
        maxRange: document.querySelector("#Filter-Price-LTE"),
        minInput: document.querySelector(".min-price"),
        maxInput: document.querySelector(".max-price"),
        progress: document.querySelector(".input-progress"),
        minBubble: document.querySelector(".min-price_bubble"),
        maxBubble: document.querySelector(".max-price_bubble"),
      },
      mobile: {
        minRange: this.querySelector(".min-range_mobile"),
        maxRange: this.querySelector(".max-range_mobile"),
        minInput: this.querySelector(".mobile_display-price.min-price"),
        maxInput: this.querySelector(".mobile_display-price.max-price"),
        progress: this.querySelector(".mobile-input-progress"),
        minBubble: this.querySelector(".mobile-min_bubble"),
        maxBubble: this.querySelector(".mobile-max_bubble"),
      }
    };
  }

  bindEvents() {
    Object.values(this.groups).forEach(group => {
      if (group.minRange) {
        group.minRange.addEventListener("input", () => this.onInput(group));
      }
      if (group.maxRange) {
        group.maxRange.addEventListener("input", () => this.onInput(group));
      }
    });
  }

  onInput(group) {
    if (this.isUpdating) return;

    this.isUpdating = true;

    this.adjustToValidValues(group.minRange);
    this.adjustToValidValues(group.maxRange);

    this.updateRange(group);

    // Sync the other device (desktop ↔ mobile)
    const otherGroup = group === this.groups.desktop
      ? this.groups.mobile
      : this.groups.desktop;

    this.syncGroups(group, otherGroup);

    this.isUpdating = false;
  }

  updateAll() {
    this.updateRange(this.groups.desktop);
    this.updateRange(this.groups.mobile);
  }

  updateRange(group) {
    if (!group?.minRange || !group?.maxRange) return;

    let min = this.toNumber(group.minRange.value);
    let max = this.toNumber(group.maxRange.value);
    const total = this.getMax(group.minRange);

    if (min == null || max == null || total == null) return;

    // Enforce minimum gap
    if (max - min < this.MIN_GAP) {
      if (max >= total) {
        min = Math.max(total - this.MIN_GAP, 0);
      } else {
        max = min + this.MIN_GAP;
      }
    }

    // Apply values (trigger filter events ONLY on main inputs)
    this.setValue(group.minRange, min, true);
    this.setValue(group.maxRange, max, true);

    // UI inputs (no event trigger)
    this.setValue(group.minInput, min);
    this.setValue(group.maxInput, max);

    this.updateProgress(group.progress, min, max, total);
    this.updateBubble(group.minBubble, min);
    this.updateBubble(group.maxBubble, max);
  }

  syncGroups(source, target) {
    if (!target?.minRange || !target?.maxRange) return;

    const min = this.toNumber(source.minRange.value);
    const max = this.toNumber(source.maxRange.value);

    this.setValue(target.minRange, min);
    this.setValue(target.maxRange, max);

    this.setValue(target.minInput, min);
    this.setValue(target.maxInput, max);

    this.updateProgress(
      target.progress,
      min,
      max,
      this.getMax(target.minRange)
    );

    this.updateBubble(target.minBubble, min);
    this.updateBubble(target.maxBubble, max);
  }

  updateProgress(progressEl, min, max, total) {
    if (!progressEl || !total) return;

    progressEl.style.left = `${(min / total) * 100}%`;
    progressEl.style.right = `${100 - (max / total) * 100}%`;
  }

  updateBubble(bubbleEl, value) {
    if (!bubbleEl) return;
    bubbleEl.textContent = value;
  }

  adjustToValidValues(input) {
    if (!input) return;

    const value = this.toNumber(input.value);
    const min = this.toNumber(input.getAttribute("min"));
    const max = this.toNumber(input.getAttribute("max"));

    if (value == null || min == null || max == null) return;

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  triggerEvent(el) {
    if (!el) return;

    el.dispatchEvent(new Event("input", { bubbles: true }));
    el.dispatchEvent(new Event("change", { bubbles: true }));
  }

  setValue(el, value, trigger = false) {
    if (!el || value == null) return;

    if (parseFloat(el.value) === value) return;

    el.value = value;

    if (trigger) {
      this.triggerEvent(el);
    }
  }

  getMax(input) {
    if (!input) return null;
    return this.toNumber(input.getAttribute("max"));
  }

  toNumber(val) {
    const num = parseFloat(val);
    return isNaN(num) ? null : num;
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });

    
    facetLink.addEventListener('click', function() {
        setTimeout(function() {
            this.setPriceFilter();
        }.bind(this), 2000);
    }.bind(this));
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);

    window.hideActiveInstockFacet();
    
    if(this.classList.contains('active-facets__button-wrapper')) {      
      var filterContainer = this.closest('.active-facets-desktop') || document.querySelector('.active-facets-desktop');
      
      if(filterContainer && !filterContainer.classList.contains("facets-drawer")) {
        filterContainer.classList.add('hidden');
      }
    }

    let currentActiveFacets = []
    let isPriceOption = null

    if (event.target.closest(".active-facets__button")) {
      const activeFacetsContainer = event.target.closest(".active-facets")

      isPriceOption = event.target.closest(".active-facets__button").querySelector(".active-facets__button-inner")

      if (activeFacetsContainer) {
        currentActiveFacets = activeFacetsContainer.querySelectorAll(".active-facets__button") || []
      }
    }

    if (event.target.closest(".mobile-facets__footer") || event.target.closest(".clear-all-button") || event.target.closest("remove-button") || currentActiveFacets.length <= 1) {

      // Clear active sortby values
      const activeSortByValue = document.querySelectorAll(".custom-sort-by-value") || [];
      if (activeSortByValue.length > 0) {
        activeSortByValue.forEach(el => {
          el.classList.remove("active")
        })
      }

      this.resetPriceFilter()

    } else if (isPriceOption && isPriceOption.innerHTML.includes("₹")) {
      this.resetPriceFilter()
    }
  }

  resetPriceFilter() {
    // Reset price inputs
    const priceRangeElemets = document.querySelectorAll("price-range") || []
    if (priceRangeElemets.length > 0) {
      priceRangeElemets.forEach(priceRange => {
        const priceInputsMin = document.querySelector("#Filter-Price-GTE")
        const priceInputsMax = document.querySelector("#Filter-Price-LTE")

        if (priceInputsMin && priceInputsMax) {
          priceInputsMin.value = priceInputsMin.min
          priceInputsMax.value = priceInputsMax.max

          priceRange.updateAll() // Update the prices and progress
        }
      })
    }
  }

  setPriceFilter() {
    //bubble price for max mobile
    const maxrange = document.querySelector(".max-price");
    const maxbubble = document.querySelector(".max-price_bubble");
    let minInput = document.querySelector("#Filter-Price-GTE");

    //for Mobile
    const MobileMaxrange = document.querySelector(".max-range_mobile");
    const MobileMaxinbubble = document.querySelector(".mobile-max_bubble");
    
    // maxrange.addEventListener("input", () => {
    //   setMaxBubble(maxrange, maxbubble);
    // });

    function setMaxBubble(range, maxbubble) {
      const val = range.value;
      const totalval= minInput.getAttribute('max');
      maxbubble.innerHTML = val;
    }

    setMaxBubble(MobileMaxrange, MobileMaxinbubble);
    //setMaxBubble(maxrange, maxbubble);
  }
}

customElements.define('facet-remove', FacetRemove);